import { InfoWithImage, InfoCardCompact } from '@hg/stylizator/components'
import { TButtonType } from '@hg/stylizator/dist/esm/components/atoms/Button/models'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { CardData } from 'app/blocks/sections/InfoWithImage/model'
import LazyLoadMedia from 'app/helpers/LazyLoadMedia'

export interface IAttributes extends React.ComponentProps<typeof InfoWithImage> {
  paragraph: string
  ctaText: string
  ctaUrl: string
  ctaTarget: string
  ctaRel: string
  ctaClassName: string
  mediaUrl: string
  showCards: boolean
  cards: CardData[]
  type: TButtonType
  videoUrl?: string
}

const InfoWithImageBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const callToAction = attributes.ctaText
    ? {
        text: attributes.ctaText,
        url: attributes.ctaUrl,
        target: attributes.ctaTarget,
        rel: attributes.ctaRel,
        className: attributes.ctaClassName,
        type: attributes.type || 'primary',
      }
    : undefined
  const mediaUrl = attributes.mediaUrl ?? ''

  return (
    <InfoWithImage
      title={attributes.title}
      paragraph={parse(attributes.paragraph ?? '')}
      image={<LazyLoadMedia mediaUrl={mediaUrl} />}
      background={attributes.background}
      reverse={attributes.reverse}
      callToAction={callToAction}
      trustpilot={attributes.trustpilot}
      videoUrl={attributes.videoUrl}
    >
      {attributes.showCards &&
        attributes.cards.map((card, index) => (
          <InfoCardCompact
            key={index}
            icon={
              <LazyLoadImage src={card.mediaUrl} alt="" width="100%" height="100%" style={{ objectFit: 'contain' }} />
            }
            title={card.title}
            body={parse(card.body ?? '')}
          />
        ))}
    </InfoWithImage>
  )
}

export default InfoWithImageBlock
